import { createSlice } from "@reduxjs/toolkit";

const interviewSlice = createSlice({
  name: "interview",
  initialState: {
    status: "idle",
    error: null,
    loading: false,
    // Interview slots data
    interviewSlots: [],
    availableSlots: [],
    // Interview bookings data
    interviewBookings: [],
    candidateBookings: [],
    // Interviewer data
    interviewerSchedule: [],
    interviewerAvailability: {},
    // Current booking details
    currentBooking: null,
    currentSlots: null,
    // Loading states
    slotsLoading: false,
    bookingLoading: false,
    scheduleLoading: false,
    // Public booking data
    publicSlots: null,
    publicBookingLoading: false,
    // Filter state
    filters: {
      status: 'all',
      dateFrom: null,
      dateTo: null,
      interviewerId: null,
      candidateId: null,
      jdId: null
    }
  },
  reducers: {
    setError: (state, action) => {
      state.error = action.payload;
      state.status = "failed";
    },    
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setSlotsLoading: (state, action) => {
      state.slotsLoading = action.payload;
    },
    setBookingLoading: (state, action) => {
      state.bookingLoading = action.payload;
    },
    setScheduleLoading: (state, action) => {
      state.scheduleLoading = action.payload;
    },
    setPublicBookingLoading: (state, action) => {
      state.publicBookingLoading = action.payload;
    },
    // Interview slots reducers
    loadInterviewSlots: (state, action) => {
      state.interviewSlots = action.payload;
    },
    setAvailableSlots: (state, action) => {
      state.availableSlots = action.payload;
    },
    setCurrentSlots: (state, action) => {
      state.currentSlots = action.payload;
    },
    // Interview bookings reducers
    loadInterviewBookings: (state, action) => {
      state.interviewBookings = action.payload;
    },
    loadCandidateBookings: (state, action) => {
      state.candidateBookings = action.payload;
    },
    setCurrentBooking: (state, action) => {
      state.currentBooking = action.payload;
    },
    // Interviewer reducers
    loadInterviewerSchedule: (state, action) => {
      state.interviewerSchedule = action.payload;
    },
    setInterviewerAvailability: (state, action) => {
      state.interviewerAvailability = action.payload;
    },
    // Public booking reducers
    setPublicSlots: (state, action) => {
      state.publicSlots = action.payload;
    },
    // Filter reducers
    setStatusFilter: (state, action) => {
      state.filters.status = action.payload;
    },
    setDateFromFilter: (state, action) => {
      state.filters.dateFrom = action.payload;
    },
    setDateToFilter: (state, action) => {
      state.filters.dateTo = action.payload;
    },
    setInterviewerFilter: (state, action) => {
      state.filters.interviewerId = action.payload;
    },
    setCandidateFilter: (state, action) => {
      state.filters.candidateId = action.payload;
    },
    setJdFilter: (state, action) => {
      state.filters.jdId = action.payload;
    },
    clearAllFilters: (state) => {
      state.filters = {
        status: 'all',
        dateFrom: null,
        dateTo: null,
        interviewerId: null,
        candidateId: null,
        jdId: null
      };
    },
    // Clear data reducers
    clearInterviewData: (state) => {
      state.interviewSlots = [];
      state.availableSlots = [];
      state.interviewBookings = [];
      state.candidateBookings = [];
      state.currentBooking = null;
      state.currentSlots = null;
      state.interviewerSchedule = [];
      state.interviewerAvailability = {};
      state.publicSlots = null;
    }
  },
});

export const {
  setError,
  setLoading,
  setSlotsLoading,
  setBookingLoading,
  setScheduleLoading,
  setPublicBookingLoading,
  loadInterviewSlots,
  setAvailableSlots,
  setCurrentSlots,
  loadInterviewBookings,
  loadCandidateBookings,
  setCurrentBooking,
  loadInterviewerSchedule,
  setInterviewerAvailability,
  setPublicSlots,
  setStatusFilter,
  setDateFromFilter,
  setDateToFilter,
  setInterviewerFilter,
  setCandidateFilter,
  setJdFilter,
  clearAllFilters,
  clearInterviewData
} = interviewSlice.actions;

// Selectors
export const selectInterviewSlots = (state) => state.interview.interviewSlots;
export const selectAvailableSlots = (state) => state.interview.availableSlots;
export const selectCurrentSlots = (state) => state.interview.currentSlots;
export const selectInterviewBookings = (state) => state.interview.interviewBookings;
export const selectCandidateBookings = (state) => state.interview.candidateBookings;
export const selectCurrentBooking = (state) => state.interview.currentBooking;
export const selectInterviewerSchedule = (state) => state.interview.interviewerSchedule;
export const selectInterviewerAvailability = (state) => state.interview.interviewerAvailability;
export const selectPublicSlots = (state) => state.interview.publicSlots;
export const selectInterviewLoading = (state) => state.interview.loading;
export const selectSlotsLoading = (state) => state.interview.slotsLoading;
export const selectBookingLoading = (state) => state.interview.bookingLoading;
export const selectScheduleLoading = (state) => state.interview.scheduleLoading;
export const selectPublicBookingLoading = (state) => state.interview.publicBookingLoading;
export const selectInterviewError = (state) => state.interview.error;
export const selectInterviewFilters = (state) => state.interview.filters;

export default interviewSlice.reducer;
